import { render } from "./ErrorPage.vue?vue&type=template&id=c6f036ec&scoped=true"
const script = {}

import "./ErrorPage.vue?vue&type=style&index=0&id=c6f036ec&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/kurdos-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f036ec"]])

export default __exports__